import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { authService, CognitoUser, ConfirmSignInRequest } from '@aslanpay/portal-common-lib';

const useConfirmSignIn = ({
  onSuccess,
  onError,
}: UseMutationOptions<CognitoUser, Error, ConfirmSignInRequest>) => {
  return useMutation<CognitoUser, Error, ConfirmSignInRequest>(
    ({ cognitoUser, code }: ConfirmSignInRequest) =>
      authService.confirmSignIn({ cognitoUser, code }),
    { onSuccess, onError }
  );
};

export default useConfirmSignIn;
